export const theme = {
    colors: {
        navBar: "#111b",
        text: "#333",
        white: "#fff",
        colorfulBackground: "#e3806c",
        red: "#911439",
    },
    breakpoints: {
        tablet: "1200px",
        mobile: "780px",
    },
    fonts: {
        weights: {
            light: 300,
            medium: 400,
            bold: 700,
            superBold: 900,
        }
    }
};